<template>
  <div class="cp-set-email main">
    <div class="divider" />

    <div class="row">
      <p><i class="far fa-envelope icon" />Shop Email</p>
      <div style="margin-top: 10px">
        <input class="input" v-model="shopEmail" placeholder="shop@email.com" />
      </div>
      <p class="hint">Shop enquiries will be sent to this email.</p>
      <div class="save-wrapper">
        <p v-if="updatingShopEmail"><i class="fa fa-spinner fa-spin" /></p>
        <p v-else class="button has-text-success" @click="saveShopEmail">
          Save
        </p>
      </div>
    </div>

    <div class="divider" />

    <div class="row">
      <p><i class="fa fa-briefcase icon" />Billing Email</p>
      <div style="margin-top: 10px">
        <input
          class="input"
          v-model="billingEmail"
          placeholder="billing@email.com"
        />
      </div>
      <p class="hint">
        Billing email address if different from your shop email.
      </p>
      <div class="save-wrapper">
        <p v-if="updatingBillingEmail"><i class="fa fa-spinner fa-spin" /></p>
        <p v-else class="button has-text-success" @click="saveBillingEmail">
          Save
        </p>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "CPSetEmail",
  components: {},
  props: {
    b: Object,
  },
  data() {
    return {
      shopEmail: null,
      billingEmail: null,
      updatingShopEmail: false,
      updatingBillingEmail: false,
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
  },
  mounted() {
    this.shopEmail = this.business.data.email;
    this.billingEmail = this.business.data.billing_email;
  },
  methods: {
    validEmail(str) {
      if (!str || str.length < 5 || !str.includes("@")) {
        this.errorToast("Invalid email<br>Type DELETE@ to remove shop email");
        return false;
      }
      return true;
    },
    saveShopEmail() {
      if (!this.validEmail(this.shopEmail)) return;
      this.updatingShopEmail = true;
      if (this.shopEmail === "DELETE@") this.shopEmail = null;
      this.saveEmail({ email: this.shopEmail });
    },
    saveBillingEmail() {
      if (!this.validEmail(this.billingEmail)) return;
      this.updatingBillingEmail = true;
      if (this.billingEmail === "DELETE@") this.billingEmail = null;
      this.saveEmail({ billing_email: this.billingEmail });
    },
    saveEmail(data) {
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: data,
        })
        .then((res) => {
          this.successToast("Updated email");
          this.business.data = res.data.data;
        })
        .catch((err) => this.apiError(err))
        .finally(() => {
          this.updatingShopEmail = false;
          this.updatingBillingEmail = false;
        });
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.hint {
  margin-top: 6px;
  margin-left: 4px;
  color: grey;
  font-size: 0.9em;
}
</style>
